import * as React from 'react';
import { themr } from 'react-css-themr';
import { GoogleMap, Marker, withGoogleMap, withScriptjs, } from 'react-google-maps';
export const defaultMyMapTheme = {
    root: 'w-100 aspect-ratio--1x1 relative',
    map: 'absolute absolute--fill',
};
const TmpMap = withScriptjs(withGoogleMap(({ center, markers, zoom, }) => (React.createElement(GoogleMap, { defaultCenter: center, defaultZoom: zoom }, markers.map((position, idx) => (React.createElement(Marker, { key: idx, position: position })))))));
export const DumpMap = (props) => {
    const { apiKey, center, markers, zoom, theme = {} } = props;
    return (React.createElement(TmpMap, { googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${apiKey}`, loadingElement: React.createElement("div", { className: "absolute absolute--fill flex items-center justify-center" }, "Loading..."), containerElement: React.createElement("div", { className: theme.root }), center: center, markers: markers, zoom: zoom, mapElement: React.createElement("div", { className: theme.map }) }));
};
const Map = themr('Map', {}, { composeTheme: 'softly' })(DumpMap);
export default Map;
//# sourceMappingURL=index.js.map